<template>
  <el-dialog :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose" :append-to-body='true'>
    <template slot="title">
      <span class="el-dialog__title">{{title}} </span>
    </template>
    <div id="dialogBoxWare" class="dialogData">
      <ul class="orderStateDetail">
        <li><span class="text_gray">{{$t('base.taxrefundamount')}}:</span>{{list.RealLowestPriceUnit}} {{list.TaxPriceUsd.toFixed(2)}}</li>
        <li><span class="text_gray">{{$t('base.orderTotal')}}:</span>{{list.RealLowestPriceUnit}} {{list.RealTotalPrice.toFixed(2)}}</li>
        <li><span class="text_gray">{{$t('base.orderNumber')}}:</span>{{list.Code}}</li>
        <li><span class="text_gray">{{$t('base.createTime')}}:</span>{{setTime(list.CreateDate)}}</li>
      </ul>
      <div class="orderListBox">
        <div class="orderList orderListTop">
          <div>{{$t('base.item')}}</div>
          <div class="operate">{{$t('base.itemPrice')}}</div>
        </div>
        <el-scrollbar>
          <ul class="orderScrollbar" >
            <li class="orderList" v-for="(item,index) in list.Details" :key="index">
              <div>{{item.Title}}</div>
              <div class="operate">{{item.RealLowestPriceUnit}} {{item.RealLowestPrice.toFixed(2)}}</div>
            </li>
          </ul>
        </el-scrollbar>
      </div>
      <div class="footer">
        <el-button class="base" @click="handleClose">{{$t('base.back')}}</el-button></div>
    </div>
  </el-dialog>
</template>
<script>
import { getTime } from "@/api/public";
export default {
  name: 'taxorderlist',
  data() {
    return {
    }
  },
  props: {
    dialogClass: '',
    title: '',
    domVisible: Boolean,
    list: {},
    userInfo: {}
  },
  watch: {},
  filters: {},
  created() {
  },
  mounted() {},
  methods: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    handleClose() {
      this.$emit('closeDialog', 'taxorderlist', false)
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer{
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
/deep/ .base {
  padding: 9px 12px;
}
#dialogBoxWare {
  min-height: 400px;
  max-height: 80vh;
}

.orderList {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.orderListTop {
  background-color: #f7f7f7;
}

.orderList>div {
  width: 75%;
  padding: 16px 12px;
  color: #333;
  box-sizing: border-box;
}


.orderList>div.operate {
  width: 15%;
}

.view {
  cursor: pointer;
}

.view:hover {
  color: #5F6DAE;
  text-decoration: underline;
}

.like_img {
  width: 104px;
  height: 104px;
  display: block;
  margin-top: 16px;
}

.orderStateDetail li {
  margin-bottom: 16px;
}

.orderStateDetail li>span {
  margin-right: 8px;
}
.orderScrollbar{
  height: 200px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/taxorderlist.vue